(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
    This file contains general functions that are used for various sections of plugin
 */

/*
    Pops up a boot modal warning

    message: (string), the message we want to show on the modal
 */
window.qipModalWarning = function () {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var modal_html = "\n                <div class=\"modal\" tabindex=\"-1\" role=\"dialog\" id=\"warning-modal-comment\">\n                  <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\n                    <div class=\"modal-content\">\n                      <div class=\"modal-header\">\n                        <h5 class=\"modal-title\"><i class=\"fas fa-exclamation-triangle mr-2\" style=\"color:#ecb811\"></i>Warning</h5>\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                          <span aria-hidden=\"true\">&times;</span>\n                        </button>\n                      </div>\n                      <div class=\"modal-body\">\n                        <p style=\"font-size:14px;\">".concat(message, "</p>\n                      </div>\n                      <div class=\"modal-footer\">\n                        <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\">Close</button>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n        ");
  //if a modal already exists from a previous error message then remove it first
  jQuery('#warning-modal-comment').remove();

  //create and display new modal
  jQuery("body").append(modal_html);
  jQuery('#warning-modal-comment').on('shown.bs.modal', function () {
    jQuery("body.modal-open").removeAttr("style");
  });
  jQuery('#warning-modal-comment').modal();
};

/*
    Check if user is verified - if false, then do an ajax check to double check that the user hasnt verified
    their account in a differnt window. Run the callback function with either "true" or "false" as a parameter


    callbackFunction: (function), action to run when function is completed

    returns: (bool), true if user is verified and false if not
 */
window.qip_check_is_user_verified = function () {
  var callbackFunction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  /*
      If we dont have the js variable that the user has been verified (either set by wp_localize or js) then do
      ajax query to double check that user has been verified
   */
  if (window.is_user_verified === false) {
    // console.log('user verigied is false - run ajax query');
    window.ajaxQueryIsUserVerified(callbackFunction);
  }
  //if user has aleady been verified then return true and run callback function
  else {
    // console.log('user has been verified!');
    callbackFunction(true);
    return true;
  }
};

/*
    Ajax query to check in database if user is verified

    callbackFunction: (function), action to run once we confirm if user is verified or not
 */
window.ajaxQueryIsUserVerified = function (callbackFunction) {
  var _self = this;
  var params = new FormData();
  params.append('action', 'mts_is_current_user_email_verified');
  params.append('logged_in_nonce', logged_in_nonce);

  //do ajax query to get status of user verification
  fetch(_self.ajaxurl, {
    method: 'POST',
    body: params
  }).then(function (res) {
    return res.json();
  })["catch"](function (error) {
    if (window.debugMTS === "1") {
      console.log('error with submission - ', error);
    }
  }).then(function (response) {
    /*
        No reponse
     */
    if (response === 0) {
      /*
          Check if user is logged in and if not then launch a warning
       */
      window.qipModalWarning('Unknown error verifying user email.');
    }

    /*
        If user email was verified set global is_user_verified to true, otherwise set to false
     */
    if (response.verified === "1" || response.verified === 1) {
      window.is_user_verified = true;
    } else {
      //if user email  was not verified return false
      window.is_user_verified = false;
    }

    /*
        Now that we've done the verification run the callback function
     */
    callbackFunction(window.is_user_verified);
  });
};

/*
    Check if user is logged into wordpress by checking if the 'logged-in' class is set in the body tag

    returns: (bool), true if logged in and false if not logged in
 */
window.qip_is_user_logged_in = function () {
  return document.body.classList.contains('logged-in');
};

/*
    If user is not logged in, then launch a modal telling user they must log in to be able to vote

    message: (string), the warning message we want to appear when showing login message on top
 */
window.launchMustBeLoggedIn = function () {
  var top_message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  //open the modal login from the themes function
  if (window.debugMTS === "1") {
    console.log('you must be logged in!', top_message);
  }
  window.openModalLogin(top_message);
};

/*
    Pops up a boot modal warning but looks positive

    message: (string), the message we want to show on the modal
 */
window.qipModalPositiveMessage = function () {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var modal_html = "\n                <div class=\"modal\" tabindex=\"-1\" role=\"dialog\" id=\"warning-modal-comment\">\n                  <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\n                    <div class=\"modal-content\">\n                      <div class=\"modal-header\">\n                        <h5 class=\"modal-title\">\n                        <img src=\"/wp-content/plugins/qip/assets/images/metaspoon_logo_square.png\" style=\"width:40px;height:40px;margin-right:10px;\">\n                        Woohoo, <span style=\"color:green;\">CONGRATULATIONS</span>!\n                        </h5>\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                          <span aria-hidden=\"true\">&times;</span>\n                        </button>\n                      </div>\n                      <div class=\"modal-body\">\n                        <p style=\"font-size:14px;line-height: normal;\">".concat(message, "</p>\n                      </div>\n                      <div class=\"modal-footer\">\n                        <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\">Close</button>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n        ");
  //if a modal already exists from a previous error message then remove it first
  jQuery('#warning-modal-comment').remove();

  //create and display new modal
  jQuery("body").append(modal_html);
  jQuery('#warning-modal-comment').on('shown.bs.modal', function () {
    jQuery("body.modal-open").removeAttr("style");
  });
  jQuery('#warning-modal-comment').modal();
};

// window.positiveMessage()
window.positiveMessage = function () {
  var message = "You have left your first comment... <b>Good work</b>! <br><br>\n\n                    You can edit your profile to let people know more about you and change your profile image <a href='https://local.metaspoon.com/user/{username}/?em=first_comment'>here</a>.\n                    <br>In the profile section you can check out all the comments and votes you've made on Metaspoon.\n\n                    <br>Thanks for participating in the comminuity and looking forward to seeing more of you!";
  window.qipModalPositiveMessage(message);
};

/*
    Copied from themes just to have in case the other one doesnt work
 */
window.getDevice = function () {
  var device;
  device = 'm';

  /* This decided what platform is being used depending on screensize and orientation */
  if (screenwidth > 991) {
    device = 'd'; //sets platform as desktop
  } else if (screenwidth <= 991 && screenwidth > 599) {
    device = 't'; //sets platform as tablet
  } else if (screenwidth <= 599) {
    device = 'm'; //sets platform as mobile
  } else {
    device = 'n';
  }
  return device;
};

/*
    This controls the upvoting bar below posts
 */

/*
    This is the class for an individual upvotes bar which we initialize below
    We have to initialize this for each upvote bar so if a sopost has 50 of these it gets initialized 50 times

 */
window.UpvotesBar = /*#__PURE__*/function () {
  /*
      Gets the dom object for the invidual upvotes bar and attaches it to this object
      so "this" is the specific dom object
   */
  function _class(upvotes_bar) {
    _classCallCheck(this, _class);
    if (window.debugMTS === "1") {
      console.log('upvotes bar class running');
    }
    /*
        Set up variables
     */

    this.upvotes_bar = upvotes_bar;
    this.upvote_icon = upvotes_bar.getElementsByClassName("mts-upvote-icon-below-post")[0];
    this.downvote_icon = upvotes_bar.getElementsByClassName("mts-downvote-icon-below-post")[0];
    this.total_points_num = upvotes_bar.getElementsByClassName("mts-upvotes-total-points")[0];
    this.total_votes_num = upvotes_bar.getElementsByClassName("mts-upvotes-total-votes")[0];
    this.story_id = upvotes_bar.getAttribute('story-id');
    this.sopost_id = upvotes_bar.getAttribute('sopost-id');

    /*
        Set event listeners
     */
    this.setEventListeners();
  }

  /*
   Set action when user clicks on buttons in modal
  */
  return _createClass(_class, [{
    key: "setEventListeners",
    value: function setEventListeners() {
      var _self = this;

      /*
          When clicking the upvote button - 1
       */
      this.upvote_icon.addEventListener('click', function (e) {
        if (!window.qip_is_user_logged_in()) {
          window.launchMustBeLoggedIn('You must be logged in to vote. You can log in directly without registering by clicking on the Facebook/Google button below!');
        } else {
          /*
              Checks if user is verified
           */
          window.qip_check_is_user_verified(function (is_verified) {
            if (!is_verified) {
              window.qipModalWarning('Sorry, you must verify your email before you can vote.');
            } else {
              _self.setUpvotedVisuals();
              _self.ajaxCallVote("up");
            }
          });
        }
      });

      /*
          When clicking the downvote button
       */
      this.downvote_icon.addEventListener('click', function (e) {
        if (!window.qip_is_user_logged_in()) {
          window.launchMustBeLoggedIn('You must be logged in to vote. You can log in directly without registering by clicking on the Facebook/Google button below!');
        } else {
          /*
              Checks if user is verified
           */
          window.qip_check_is_user_verified(function (is_verified) {
            if (!is_verified) {
              window.qipModalWarning('Sorry, you must verify your email before you can vote.');
            } else {
              _self.setDownvotedVisuals();
              _self.ajaxCallVote("down");
            }
          });
        }
      });

      /*
          If user logs in without reload then update all upvote/downvote data with latest user data for upvotes
            We only want this to run once on the page, so that we dont pull all votes data more than one time
       */
      if (typeof window.qip_updated_upvotes_event_set_once === 'undefined') {
        window.qip_updated_upvotes_event_set_once = true; //set variable to true so that we only pull update votes once for all stories, instead of every time a votes bar is loaded

        document.addEventListener("logged_in_without_reload_event", function (e) {
          // console.log('QIP UPVOTES!!! - Weve logged in!');
          var qip_updated_upvotes = _self.ajaxQueryGetVotesDataForUserID(_self.sopost_id);
        });
      }
    } //end set event listeners

    /*
        Ajax call for up and down buttons
     */
  }, {
    key: "ajaxCallVote",
    value: function ajaxCallVote(vote) {
      var _self = this;
      var ajaxurl = this.upvotes_bar.dataset.url;
      var params = new FormData(); //create url parameter object to send to ajax request

      //set votes variable based on vote
      if (vote === "up") {
        params.append('vote', 'up');
      } else if (vote === "down") {
        params.append('vote', 'down');
      }
      params.append('action', 'mts_upvote');
      params.append('logged_in_nonce', logged_in_nonce);
      params.append('story-id', this.story_id);
      params.append('sopost-id', this.sopost_id);

      // console.log(`this.post_id: ${params.get('post-id')}
      // this.logged_in_nonce : ${params.get('mts-upvotes-nonce')}
      // action: ${params.get('action')}
      // `);

      //do ajax query to password reset
      fetch(ajaxurl, {
        method: 'POST',
        body: params
      }).then(function (res) {
        return res.json();
      })["catch"](function (error) {
        if (window.debugMTS === "1") {
          console.log('error with submission - ', error);
        }
      }).then(function (response) {
        if (window.debugMTS === "1") {
          console.log('response:', response);
        }
        if (response === 0 || !response.status) {
          /*
              Check if user is logged in and if not then launch a warning
           */
          if (window.debugMTS === "1") {
            console.log('response.logged_in:', response.logged_in, ', and type is:', _typeof(response.logged_in));
          }
          if (response.logged_in === false) {
            if (window.debugMTS === "1") {
              console.log('1 - must be logged in');
            }
            window.launchMustBeLoggedIn('You must be logged in to vote. You can log in directly without registering by clicking on the Facebook/Google button below!');
          }
        }
      });
    }

    /*
        Sets the visual effects for upvoting by:
            -sets upvoted button to clicked (adds 'voted' class to upvote button)
            -sets downvoted button to unclicked (removes 'voted' class from downvote button)
            -increases the points total by one
            -unclicks button if already selected
       */
  }, {
    key: "setUpvotedVisuals",
    value: function setUpvotedVisuals() {
      var clicked = this.whatVoteButtonIsClicked();

      //if upvote is already clicked, then unclick it and subtract a total point
      if (clicked === "up") {
        this.upvote_icon.classList.remove('voted');
        this.subtractPoint();
        this.subtractTotalVote();
      }
      //if upvote button is not yet clicked then set it as clicked and add 1 to total
      else {
        this.upvote_icon.classList.add('voted');
        this.addPoint();

        //if the downvote is clicked then removed "voted" class from it and add one to the total points
        if (clicked === "down") {
          this.downvote_icon.classList.remove('voted');
          this.addPoint();
        } else {
          this.addTotalVote();
        }
      }
    }

    /*
    Sets the visual effects for downvoting by:
        -sets downvoted button to clicked (adds 'voted' class to upvote button)
        -sets upvoted button to unclicked (removes 'voted' class from downvote button)
        -decreases the points total by one
        -unclicks button if already selected
       */
  }, {
    key: "setDownvotedVisuals",
    value: function setDownvotedVisuals() {
      var clicked = this.whatVoteButtonIsClicked();

      //check if downvote is already clicked and if so unclick it and add 1 to total points
      if (clicked === "down") {
        this.downvote_icon.classList.remove('voted');
        this.addPoint();
        this.subtractTotalVote();
      }
      //if its not clicked, then click it and subtract 1 to total points
      else {
        //set upvoted button and add one to the total points
        this.downvote_icon.classList.add('voted');
        this.subtractPoint();

        //if the updated is clicked then remove "voted" class from it and subtract one to the total points
        if (clicked === "up") {
          this.upvote_icon.classList.remove('voted');
          this.subtractPoint();
        } else {
          this.addTotalVote();
        }
      }
    }

    /*
        Checks which button has been clicked and returns value:
            -if upvote has been clicked returns "up"
            -up downvote has been clicked returns "down"
            -if none have been clicked returns "none"
          returns: (string), the name of the button that is pre-clicked "up", "down" or "none"
     */
  }, {
    key: "whatVoteButtonIsClicked",
    value: function whatVoteButtonIsClicked() {
      if (this.upvote_icon.classList.contains('voted')) return "up";else if (this.downvote_icon.classList.contains('voted')) return "down";else return "none";
    }

    /*
        Visually add a point to the total score (only visual not in api)
     */
  }, {
    key: "addPoint",
    value: function addPoint() {
      this.total_points_num.innerText = parseInt(this.total_points_num.innerText) + 1;
    }

    /*
        Visually subtract a point to the total score (only visual not in api)
     */
  }, {
    key: "subtractPoint",
    value: function subtractPoint() {
      this.total_points_num.innerText = parseInt(this.total_points_num.innerText) - 1;
    }

    /*
        Visually add a vote to the total votes score (only visual not in api)
     */
  }, {
    key: "addTotalVote",
    value: function addTotalVote() {
      //if we are not displaying total votes, as in the story feed, then skip this
      console.log('tyyyype xxxx:', _typeof(this.total_votes_num));
      if (typeof this.total_votes_num !== 'undefined') this.total_votes_num.innerText = parseInt(this.total_votes_num.innerText) + 1;
    }

    /*
        Visually add a vote to the total votes score (only visual not in api)
     */
  }, {
    key: "subtractTotalVote",
    value: function subtractTotalVote() {
      //if we are not displaying total votes, as in the story feed, then skip this
      if (typeof this.total_votes_num !== 'undefined') this.total_votes_num.innerText = parseInt(this.total_votes_num.innerText) - 1;
    }

    /*
        Ajax query to get votes data for all stories in article so we can dynamically set up and down votes for specific user
        once they are logged into the site with the "login with no reload" functionality
          sopost_id: (int), the article we want to get votes for
          returns: (array or obj?), contains the up or downvote for each story for user for this sopost
     */
  }, {
    key: "ajaxQueryGetVotesDataForUserID",
    value: function ajaxQueryGetVotesDataForUserID(sopost_id) {
      // console.log('window logged_in_nonce',window.logged_in_nonce);

      // console.log(`about to run ajax query: ajaxQueryGetVotesDataForUserID
      //     sopost_id: ${sopost_id}
      // `);

      var ajaxurl = this.upvotes_bar.dataset.url;
      var params = new FormData();
      params.append('action', 'get_votes_data_for_user_for_sopost');
      params.append('sopost_id', sopost_id);
      params.append('logged_in_nonce', logged_in_nonce);

      /*
          Do ajax query to get an array with votes for user for sopost
       */
      fetch(ajaxurl, {
        method: 'POST',
        body: params
      }).then(function (res) {
        return res.json();
      })["catch"](function (error) {
        if (window.debugMTS === "1") {
          console.log('error with submission - ', error);
        }
      }).then(function (response) {
        if (window.debugMTS === "1") {
          console.log('response:', response);
        }
        if (response === 0 || !response.status) {
          /*
              Check if user is logged in and if not then launch a warning
           */
          if (window.debugMTS === "1") {
            console.log('Error: ', response.message);
          }
        }
        if (response.status === true) {
          var upvote_bars = document.querySelectorAll('.mts-upvotes-bar-sopost');
          /*
              Go through each upvote bar and get the sopost id and story id and then check if there is a
              matching result in the upvotes array from the ajax query. If so then change the graphical
              result to whatever the result is. Ie. if upvote is set to 1, then change to upvote graphically
           */
          upvote_bars.forEach(function (e) {
            var story_id = e.getAttribute('story-id');
            var sopost_id = e.getAttribute('sopost-id');

            //check if there is a vote in array
            var vote = response.votes_array["sopost_".concat(sopost_id, "_story_").concat(story_id)];
            if (vote) {
              /*
                  If we have an upvote/downvote add a "voted" class to the appropriate icon to indicate vote
               */
              if (vote === "1") {
                e.getElementsByClassName('mts-upvote-icon-below-post')[0].classList.add('voted');
              } else if (vote === "-1") {
                e.getElementsByClassName('mts-downvote-icon-below-post')[0].classList.add('voted');
              }
            }
          });
        }
      });
    }
  }]);
}();

/*
    Initialize all upvotes bars on screen
 */
window.initializeAllUpvotesBars = function () {
  /*
  Create a function that creates each upvotes bar for each story
   */

  this.all_upvote_bars = document.querySelectorAll('[data-upvote]');
  this.all_upvote_bars.forEach(function (upvote_bar) {
    /*
        First check if upvote bar has already been initialized - if it hasnt set it to initialized
     */
    //add attribute 'init' to button so we dont mistakenly initialize it twice
    if (upvote_bar.getAttribute('init')) return;else {
      upvote_bar.setAttribute('init', 'true');
    }

    /*
        If it hasnt been initialized yet then proceed to initialize it
     */
    var upvote_bar_instance = new UpvotesBar(upvote_bar);
  });
};

/*
    Initialize all upvotes bars when dom is loaded
 */
document.addEventListener("DOMContentLoaded", function () {
  window.initializeAllUpvotesBars();
});

},{}]},{},[1]);
